<template>
  <div
    class="ev_compare-picker evcmprpickr"
    :class="{ 'no-events evcmprpickr_error': studyEvCompare.disabled }"
  >
    <!-- <svg
      style="
        height: 100vh;
        width: 100vw;
        position: fixed;
        top: 0;
        height: 100vh;
        opacity: 0.5;
      "
    >
      <path :d="overlayPath"></path>
    </svg> -->
    <div class="evcmprpickr_content">
      <svg
        v-if="!studyEvCompare.disabled"
        ref="svg"
        class="evcmprpickr_svg"
        width="100%"
        height="100%"
        viewBox="0 0 1 1"
        preserveAspectRatio="none"
      >
        <path
          class="evcmprpickr_svg_path anim-fade-in-timed"
          style="--anim-duration: 0.7s"
          :d="connectionPath"
          fill="transparent"
          vector-effect="non-scaling-stroke"
        ></path>
      </svg>
      <div class="evcmprpickr_content_column">
        <div class="evcmprpickr_content_column_top">
          {{ $t('ev_comparison.action_primary') }}
        </div>
        <div class="evcmprpickr_actions">
          <div
            v-for="aa in actions.filter(i => i.action_id !== 'best_ev_action')"
            :key="aa.action_id"
            class="evcmprpickr_actions_item"
          >
            <div
              :ref="`${aa.action_id}_primary`"
              class="svg_line_target svg_line_target_start"
            ></div>
            <div
              class="gw_btn evcmprpickr_actions_item_btn"
              :class="[
                {
                  gw_btn_active: evca.action_primary.action_id === aa.action_id,
                },
              ]"
              @click="setAction(aa, 'action_primary')"
              v-html="
                aa.group_display_name
                  ? $t(`browse.${aa.group_display_name}`)
                  : getBetHtml({
                      showBetsIn,
                      a: aa,
                      name: true,
                      simple: false,
                      pot_css_class: 'bet-as-pot bet-as-pot-right',
                    })
              "
            ></div>
            <!-- {
                  'no-events opacity_5':
                    evca.action_secondary.action_id === aa.action_id
                } -->
            <div
              :ref="aa.action_id"
              class="svg_line_target svg_line_target_start"
            ></div>
          </div>
        </div>
      </div>
      <!-- <div class="evcmprpickr_versus">{{ $t('common.versus_short') }}</div> -->
      <div class="evcmprpickr_content_column">
        <div class="evcmprpickr_content_column_top">
          {{ $t('ev_comparison.action_secondary') }}
        </div>
        <div class="evcmprpickr_actions">
          <div
            v-for="aa in actions"
            :key="aa.action_id"
            class="evcmprpickr_actions_item"
            :class="`evcmprpickr_actions_item_${aa.action_id}`"
          >
            <div
              :ref="`${aa.action_id}_secondary`"
              class="svg_line_target svg_line_target_end"
            ></div>
            <div
              v-if="aa.action_id === 'best_ev_action'"
              class="evcmprpickr_actions_item_best_ev_action_divider"
            ></div>
            <div
              class="gw_btn evcmprpickr_actions_item_btn"
              :class="[
                {
                  gw_btn_active: evca.compare_by_best_ev_action
                    ? aa.action_id === 'best_ev_action'
                    : aa.action_id === evca.action_secondary.action_id,
                },
              ]"
              @click="setAction(aa, 'action_secondary')"
              v-html="
                aa.group_display_name
                  ? $t(`browse.${aa.group_display_name}`)
                  : getBetHtml({
                      showBetsIn,
                      a: aa,
                      name: true,
                      simple: false,
                      pot_css_class: 'bet-as-pot bet-as-pot-right',
                    })
              "
            ></div>
            <!-- {
                  'no-events opacity_5':
                    evca.action_primary.action_id === aa.action_id
                } -->
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="evcmprpickr_content" v-if="showRegret">
      <div class="evcmprpickr_content_column">
        <div class="evcmprpickr_actions">
          <div
            class="evcmprpickr_actions_item"
            v-for="aa in actions"
            :key="aa.action_id"
          >
            <div
              class="gw_btn evcmprpickr_actions_item_btn"
              @click="setAction(aa, 'action_ev_regret')"
              :class="[
                {
                  gw_btn_active:
                    evca.action_ev_regret.action_id === aa.action_id
                }
              ]"
              v-html="
                aa.group_display_name
                  ? $t(`browse.${aa.group_display_name}`)
                  : getBetHtml({
                      showBetsIn,
                      a: aa,
                      name: true,
                      simple: false
                    })
              "
            ></div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { nextTick } from 'vue'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

import { getCubicBezier4pointPath } from '@/helpers/helpers'
import findLast from 'lodash/findLast'

export default {
  name: 'EvComparePicker',
  mixins: [format_mix, float_mix],
  props: {
    showComparison: { type: Boolean, default: true },
    instaApply: Boolean,
    // showRegret: Boolean,
  },
  data() {
    return {
      evca: {
        action_primary: {},
        action_secondary: {},
        compare_by_best_ev_action: false,
      },
      connectionPath: 'M 0.5 0.5C 0.5 0.5, 0.5 0.5, 0.5 0.5',
      // connectionPath: 'M 0 1C 0.5 1, 0.5 0, 1 0',
    }
  },
  mounted() {
    this.initialize()
  },
  methods: {
    initialize() {
      const evcActions = this.$store.getters.sol_filter_ev_comparison
      // console.log(this.studyEvCompare)
      this.evca = {
        action_primary: evcActions.action_primary,
        action_secondary: evcActions.action_secondary,
        compare_by_best_ev_action: evcActions.compare_by_best_ev_action,
      }
      nextTick(() => {
        setTimeout(() => {
          this.getConnectionPath()
        }, 120)
      })
    },
    setAction(action, type) {
      if (this.studyEvCompare.disabled) return

      if (action.action_id === 'best_ev_action') {
        this.evca = {
          ...this.evca,
          compare_by_best_ev_action: true,
        }
        this.getConnectionPath()
        if (this.instaApply) {
          this.apply()
        }
        return
      }

      const actions = this.actions.filter(a => a.action_id !== 'best_ev_action')
      if (type === 'action_primary' && this.evca.action_secondary.action_id === action.action_id) {
        this.evca = {
          ...this.evca,
          action_secondary: findLast(actions, a => a.order !== action.order),
        }
      }
      if (type === 'action_secondary' && this.evca.action_primary.action_id === action.action_id) {
        this.evca = {
          ...this.evca,
          action_primary: findLast(actions, a => a.order !== action.order),
        }
      }
      this.evca = {
        ...this.evca,
        compare_by_best_ev_action: type.includes('secondary')
          ? false
          : this.evca.compare_by_best_ev_action,
        [type]: action,
      }
      // debugger

      this.getConnectionPath()
      if (this.instaApply) {
        this.apply()
      }

      // let el = document.querySelectorAll('[tour="rangetable"]')
      // let { width, height, x, y } = el[0].getBoundingClientRect()
      // let svgOverlay = getOverlayPath({ width, height, x, y, r: 4 })
      // console.log(svgOverlay)
      // this.overlayPath = svgOverlay
    },
    getConnectionPath() {
      const boundaryEl = this.$refs.svg
      const refId1 = `${this.evca?.action_primary?.action_id}_primary`
      const refId2 = this.evca.compare_by_best_ev_action
        ? `best_ev_action_secondary`
        : `${this.evca?.action_secondary?.action_id}_secondary`
      const startEl = this.$refs[refId1]?.[0]
      const endEl = this.$refs[refId2]?.[0]
      if (!boundaryEl || !startEl || !endEl) {
        return
      }
      const res = getCubicBezier4pointPath({
        boundaryEl,
        startEl,
        endEl,
      })
      // console.log(res)
      this.connectionPath = res
    },
    apply() {
      const res = {
        ...this.studyEvCompare,
        ...this.evca,
      }
      this.$store.commit('sol_filters_set', { key: 'ev_comparison_actions', value: res })
    },
  },
  computed: {
    actions() {
      if (this.studyEvCompare.disabled) {
        return [...new Array(3).keys()].map((_, idx) => ({
          action_id: `E${idx + 1}`,
        }))
      }
      const best_ev_action = {
        action_id: 'best_ev_action',
        display_name: this.$t('ev_comparison.best_ev_action'),
      }
      const res = [...(this.studyEvCompare.actions || []), best_ev_action]
      return res
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    studyEvCompare() {
      return this.$store.getters.sol_filter_ev_comparison
    },
  },
  watch: {
    studyEvCompare: {
      handler: 'initialize',
      immediate: false,
    },
    showComparison: {
      handler: 'initialize',
      immediate: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.evcmprpickr {
  display: flex;
  flex-direction: column;
  --padding-content: 0;
  &_content {
    display: flex;
    gap: 3rem;
    position: relative;
    padding: var(--padding-content);
    &_column {
      width: 100%;
      min-width: 9rem;
      &_top {
        font-size: 0.875rem;
        text-align: center;
        padding: 0 0 0.5rem 0;
        color: var(--clr-grey-2);
      }
    }
    .evcmprpickr_svg {
      position: absolute;
      height: 100%;
      width: 100%;
      &_path {
        stroke: var(--clr-primary);
        stroke-width: 2;
        fill: none;
        transition: 0.22s;
      }
    }
  }
  &_error {
    .evcmprpickr_actions_item {
      opacity: 0.4;
      .evcmprpickr_actions_item_btn {
        color: transparent !important;
      }
    }
  }
  &_actions {
    display: flex;
    gap: 0.25rem;
    flex-direction: column;
    &_item {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      &_btn {
        font-weight: 500;
        font-size: 1rem;
        width: 100%;
        --clr-active-white: var(--clr-primary);
        --clr-hover-white: var(--clr-primary);
        --height: 2rem;

        padding: 0 0.75rem;
        justify-content: flex-start;
        white-space: nowrap;
      }
      &_best_ev_action {
        position: relative;
      }
      .svg_line_target {
        position: absolute;
        &_start {
          right: 0;
        }
        &_end {
          left: 0;
        }
      }
    }
  }
}
</style>
